var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCry = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 79,
    viewBox: "0 0 140 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9641_769",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 140,
    height: 79
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 78.2609,
    rx: 8,
    fill: "#C7AAFA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9641_769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.913 88.6955C139.366 88.6955 160 68.0617 160 42.6086C160 17.1554 139.366 -3.47839 113.913 -3.47839C88.46 -3.47839 67.8262 17.1554 67.8262 42.6086C67.8262 50.909 70.0205 58.6969 73.8607 65.4239",
    stroke: "#FFC61B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.637 36.7794C106.647 36.1985 105.534 35.6785 104.348 35.2335C103.912 35.0703 103.467 34.9172 103.014 34.7749C99.7202 33.7395 96.026 33.2759 92.8558 33.6542C91.2136 33.8501 90.106 33.8201 89.4492 33.6017C88.1886 33.1825 88.589 32.0696 90.0595 30.5289C95.6522 24.669 106.838 26.2316 110.433 33.6542C111.172 35.1781 111.568 36.6993 111.107 37.3913",
    stroke: "#7F39FA",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.699 44.5289L130.096 51.944L126.889 66.7741L125.164 74.7535",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.813 48.4949L103.417 41.0798L103.725 39.6558M80.8699 75.1882L88.8611 38.2317M96.1095 74.8728L98.6065 63.325L100.21 55.9099",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.61 17.8511C95.5229 17.8511 87.6969 21.7642 84.2186 27.4164",
    stroke: "#7F39FA",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.972 41.7952C148.326 42.5439 148.59 43.2628 148.724 43.8654C148.862 44.4825 148.829 44.8216 148.783 44.951C148.752 44.9558 148.696 44.96 148.608 44.9522C148.215 44.9177 147.497 44.678 146.347 43.9878C141.817 41.27 135.073 39.7096 129.624 40.3744C128.353 40.5295 127.454 40.5442 126.854 40.4671C126.48 40.4191 126.301 40.3463 126.225 40.3058C126.236 40.2556 126.262 40.1737 126.32 40.0509C126.491 39.6909 126.849 39.1964 127.433 38.5711C130.212 35.5937 134.425 34.4611 138.454 35.0731C142.479 35.6846 146.182 38.017 147.972 41.7952ZM126.219 40.3716C126.218 40.3719 126.217 40.3677 126.218 40.3581C126.219 40.3666 126.219 40.3714 126.219 40.3716Z",
    stroke: "#7F39FA",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.33 60.7132C105.399 55.7698 110.273 52.6289 115.216 53.6978C120.16 54.7667 123.301 59.6407 122.232 64.5841L120.697 71.6806L120.546 72.3822C119.506 77.1888 114.767 80.2428 109.96 79.2035L109.837 79.1767L109.713 79.1499C104.769 78.081 101.629 73.207 102.697 68.2636L104.33 60.7132Z",
    stroke: "#7F39FA",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9641_769)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 137.5,
    height: 75.7609,
    rx: 6.75,
    stroke: "#7F39FA",
    strokeWidth: 2.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9641_769",
    x: -11,
    y: -11,
    width: 162,
    height: 100.261,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_9641_769"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.498039 0 0 0 0 0.223529 0 0 0 0 0.980392 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9641_769"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9641_769",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCry);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cry.0dc439d6875e78202511a41cb9186812.svg";